/**
 * BINGE CLUB — RETRO CABLE GUIDE CHATBOT & CONCIERGE
 * Lightweight, zero-dependency, retro broadcast styling.
 * Scalable show search & request flow.
 */

(function () {
  'use strict';

  // --- KNOWLEDGE BASE: FRANCHISES & CHANNELS ---
  const CHANNELS = [
    {
      id: '90s-sitcom',
      title: '📺 90s Sitcom',
      fandom: 'In Store',
      handle: '90s-sitcom',
      desc: "Vintage coffeehouse banter, the Moist Maker leftover sandwich, the iconic yellow peephole door, Pivot!, Unagi, and holiday memories.",
      topPicks: ["The Moist Maker Leftover Sandwich Crewneck","Yellow Door Peephole Frame Hoodie"],
      url: '/collections/90s-sitcom'
    },
    {
      id: 'pirate-king',
      title: '🏴‍☠️ Pirate King',
      fandom: 'In Store',
      handle: 'pirate-king',
      desc: "Straw Hat voyages, the smiling pirate captain, master swordsman duels, beloved caravel farewells, and high seas nakama adventures.",
      topPicks: ["Snowy Farewell at Sea Pirate Hoodie","I Want To Live Unisex Crewneck"],
      url: '/collections/pirate-king'
    },
    {
      id: 'comic-legends',
      title: '🦸 Comic Legends',
      fandom: 'In Store',
      handle: 'comic-legends',
      desc: "Earth’s mightiest protectors, cosmic hero gatherings, web-slinger acrobatics, glorious purpose, and comic universe lore.",
      topPicks: ["Salute Forever Superhero Graphic Hoodie","Glorious Purpose Quote Crewneck"],
      url: '/collections/comic-legends'
    },
    {
      id: 'dark-vigilante',
      title: '🦇 Dark Vigilante',
      fandom: 'In Store',
      handle: 'dark-vigilante',
      desc: "Rain-slicked city storm clouds, chaos agent theatrics, burning mob money, and the night signal beaming into the skyline.",
      topPicks: ["Money Burns Chaos Agent Crewneck","Warning Not A Signal Graphic Tee"],
      url: '/collections/dark-vigilante'
    },
    {
      id: 'albuquerque-empire',
      title: '🧪 Albuquerque Empire',
      fandom: 'In Store',
      handle: 'albuquerque-empire',
      desc: "Desert RV cook sites, pure blue chemistry, fast food chicken fronts, desert criminal lawyers, and underground empire ambition.",
      topPicks: ["Better Criminal Graphic Tee","Better Criminal Crewneck Sweatshirt"],
      url: '/collections/albuquerque-empire'
    },
    {
      id: 'iron-realm',
      title: '🐉 Iron Realm',
      fandom: 'In Store',
      handle: 'iron-realm',
      desc: "Direwolf pack silhouettes, three-headed dragon sigils, the sovereign forged throne, northern fortress walls, and medieval dynasty lore.",
      topPicks: ["Direwolf Pack Silhouette Crewneck","Crown Bargain Forged Throne Hoodie"],
      url: '/collections/iron-realm'
    },
    {
      id: 'consulting-detective',
      title: '🔍 Consulting Detective',
      fandom: 'In Store',
      handle: 'consulting-detective',
      desc: "221B Baker Street, the brilliant consulting sleuth, Mind Palace deductions, violin melodies, and foggy London mystery lore.",
      topPicks: ["Consulting Detective Minimalist Graphic Hoodie","221B Baker Street Iconic Case Files Graphic Hoodie"],
      url: '/collections/consulting-detective'
    },
    {
      id: 'scranton-branch',
      title: '📎 Scranton Branch',
      fandom: 'In Store',
      handle: 'scranton-branch',
      desc: "Executive ceramic mugs, classic breakroom pranks, stapler-in-jello, paper company mockumentary lore, and Pennsylvania office nostalgia.",
      topPicks: ["The Best Boss Mug Iconic Graphic Hoodie","Jello Stapler Mockumentary Graphic Tee"],
      url: '/collections/scranton-branch'
    },
    {
      id: 'breathing-swordsman',
      title: '⚔️ Breathing Swordsman',
      fandom: 'In Store',
      handle: 'breathing-swordsman',
      desc: "Elemental breathing techniques, flame katanas, Wisteria torii gates, Boar mask warriors, and demon-hunting anime streetwear.",
      topPicks: ["Fire Sword Master Anime Graphic Pullover Hoodie","No Sound In Pool Shonen Anime Aesthetic Crewneck Sweatshirt"],
      url: '/collections/breathing-swordsman'
    },
    {
      id: 'walled-kingdom',
      title: '🛡️ Walled Kingdom',
      fandom: 'In Store',
      handle: 'walled-kingdom',
      desc: "Bastion sentinel heroism, three-walled bastions, colossal encounters, high-speed maneuvers, and anime streetwear.",
      topPicks: ["Wings of Freedom No Regrets Hoodie","Colossal Stomp Graphic T-Shirt"],
      url: '/collections/walled-kingdom'
    },
    {
      id: 'hidden-shinobi',
      title: '🍃 Hidden Shinobi',
      fandom: 'In Store',
      handle: 'hidden-shinobi',
      desc: "Will of Fire, shadow clones, ocular jutsu, rogue ninja cloaks, and legendary shinobi anime streetwear.",
      topPicks: ["Shadow Protector Shinobi Hoodie","Relentless Determination Graphic Tee"],
      url: '/collections/hidden-shinobi'
    },
    {
      id: 'galactic-saga',
      title: '⚔️ Galactic Saga',
      fandom: 'In Store',
      handle: 'galactic-saga',
      desc: "Ancient orders of light and dark, twin suns, starfighters, mythic armor, and deep space saga streetwear.",
      topPicks: ["Galactic Saga Graphic Hoodie","Galactic Flight Group Graphic Tee"],
      url: '/collections/galactic-saga'
    },
    {
      id: '80s-supernatural-mystery',
      title: '🚲 80s Supernatural Mystery',
      fandom: 'In Store',
      handle: '80s-supernatural-mystery',
      desc: "Small town bike trails, the dark mirror dimension, shadow creatures, pizza delivery vans, and 80s synth mystery lore.",
      topPicks: ["Turn Around 80s Supernatural Mystery TV Graphic Hoodie","Strange Heavy Metal 80s Supernatural Mystery TV Graphic Hoodie"],
      url: '/collections/80s-supernatural-mystery'
    },
    {
      id: 'underground-society',
      title: '🧼 Underground Society',
      fandom: 'In Store',
      handle: 'underground-society',
      desc: "Late-night basement rules, soapmaker rebellion, insomnia existentialism, single-serving flights, and 90s cult cinema aesthetics.",
      topPicks: ["Yolo 90s Underground Thriller Cinema Pop Culture Classic TV Graphic Hoodie","The Great Depression 90s Underground Thriller Cinema Pop Culture Classic TV Graphic Hoodie"],
      url: '/collections/underground-society'
    },
    {
      id: 'cursed-buccaneer',
      title: '🧭 Cursed Buccaneer',
      fandom: 'In Store',
      handle: 'cursed-buccaneer',
      desc: "Heavyweight high-seas adventure streetwear, vintage wash graphic tees, and cozy fleece hoodies inspired by runaway waterwheel duels, cursed Aztec gold, mythical kraken lore, and rogue captain swagger.",
      topPicks: ["Waterwheel Treasure Swashbuckling Pirate Movie Graphic Hoodie","Tribal King Swashbuckling Pirate Movie Graphic Hoodie"],
      url: '/collections/cursed-buccaneer'
    },
    {
      id: 'cursed-sorcerers',
      title: '🔮 Cursed Sorcerers',
      fandom: 'In Store',
      handle: 'cursed-sorcerers',
      desc: "Heavyweight Japanese dark fantasy streetwear, cozy fleece hoodies, and premium graphic tees inspired by cursed energy, domain expansion barr",
      topPicks: ["Sparks Of Black Cursed Sorcerer Shonen Anime Graphic Hoodie","Shadow Wolves Cursed Sorcerer Shonen Anime Graphic Hoodie"],
      url: '/collections/cursed-sorcerers'
    },
    {
      id: 'flight-of-the-court',
      title: '🏐 Flight Of The Court',
      fandom: 'In Store',
      handle: 'flight-of-the-court',
      desc: "Heavyweight high-school volleyball streetwear, cozy fleece hoodies, and graphic tees inspired by the view from the summit, relentless court ",
      topPicks: ["Tomorrow Never Dies Volleyball Shonen Anime Graphic Hoodie","There's Always Tomorrow Volleyball Shonen Anime Graphic Hoodie"],
      url: '/collections/flight-of-the-court'
    }
  ];

  // --- STATIC POLICIES & KNOWLEDGE ---
  const KNOWLEDGE = {
    sizing: {
      text: `<strong>📏 Garment Fit &amp; Unisex Sizing:</strong><br>
        All Binge Club apparel is crafted with premium heavyweight fleece (sweatshirts &amp; hoodies) and ringspun combed cotton (tees).<br><br>
        • <strong>True to Size:</strong> Standard tailored retail fit.<br>
        • <strong>Vintage 90s Oversized:</strong> We recommend sizing <strong>UP one size</strong> for a relaxed streetwear drape.<br>
        • Sizes available: S through 3XL across all core releases.`,
      hasSizeChartBtn: true
    },
    shipping: {
      text: `<strong>🚚 Production &amp; Shipping Policy:</strong><br>
        ✨ <strong>FREE TRACKED WORLDWIDE SHIPPING ON ALL ORDERS!</strong><br>
        <em>No minimum purchase required — free shipping is automatically applied at checkout.</em><br><br>
        Every piece is made to order and dispatched from our <strong>production studios</strong> across the United States, United Kingdom, European Union, and Australia.<br><br>
        • <strong>Order Preparation:</strong> 1 to 3 business days handling.<br>
        • <strong>United States:</strong> 2–5 business days <em>(USPS / UPS Tracked)</em>.<br>
        • <strong>United Kingdom:</strong> 2–3 business days <em>(Tracked Local Courier)</em>.<br>
        • <strong>France:</strong> 3–5 business days <em>(La Poste / Colissimo Tracked)</em>.<br>
        • <strong>Oceania / Australia:</strong> 3–6 business days <em>(Australia Post Tracked)</em>.<br>
        • <strong>Canada &amp; Asia:</strong> 7–14 business days <em>(Tracked Airmail)</em>.<br>
        • <strong>Europe &amp; New Zealand:</strong> 5–10 business days <em>(Local Post Tracked)</em>.<br>
        • <strong>Rest of the World:</strong> 8–15 business days <em>(Tracked International Airmail)</em>.<br>
        • <strong>Metal Posters &amp; Wall Art:</strong> 5–10 business days worldwide with tracked courier delivery.<br><br>
        <em>✓ Orders to the US, UK, EU, AU, and NZ arrive with zero unexpected import fees or duties.</em><br><br>
        <a href="/pages/track-order" class="binge-chat-channel-btn" style="color:#fff;">📦 Open Track Order Page</a>`
    },
    care: {
      text: `<strong>🧼 Garment Care Instructions:</strong><br>
        To keep your graphic print crisp and vibrant for years:<br>
        • Machine wash cold, inside-out, with like colors.<br>
        • Tumble dry on low heat, or hang dry for best longevity.<br>
        • Avoid ironing directly over the printed graphic.`
    },
    returns: {
      text: `<strong>🔄 30-Day Quality Guarantee &amp; Cancellation Policy:</strong><br>
        • <strong>30-Day Quality Guarantee:</strong> If your order arrives damaged, defective, misprinted, or incorrect, email clear photos to <a href="mailto:support@thebingeclub.co">support@thebingeclub.co</a> within <strong>30 days of delivery</strong>. We will arrange a <strong>100% free replacement</strong> or a <strong>full refund</strong>—no need to mail faulty items back!<br>
        • <strong>Made-to-Order &amp; Change of Mind:</strong> Every piece is crafted specifically for your order. Because made-to-order items cannot be restocked or resold, we cannot accept returns or exchanges for change of mind, ordering an incorrect size, or selecting an unwanted colour (please consult our sizing guides before ordering!).<br>
        • <strong>Order Cancellations:</strong> Orders can be modified or cancelled within <strong>24 hours of placement</strong> before moving into production.<br>
        • <strong>$0 Fees:</strong> Restocking fees are $0.00 and you never pay return shipping.<br><br>
        Need help? Reach out via our <a href="/pages/contact">Contact page</a> or email <a href="mailto:support@thebingeclub.co">support@thebingeclub.co</a>.`
    },
    fanArt: {
      text: `<strong>🎨 Original Artwork &amp; Design Philosophy:</strong><br>
        All artwork at The Binge Club consists of 100% original graphic designs created in-house, inspired by comfort-watch culture, iconic television aesthetics, and cult cinematic nostalgia.<br><br>
        We are an independent creative streetwear brand celebrating the art of great storytelling through subtle, inside-lore apparel.`
    },
    posters: {
      text: `<strong>🖼️ Metal Posters &amp; Displate-Style Wall Art:</strong><br>
        Elevate your space with collector-grade aluminum metal art prints:<br><br>
        • <strong>HD Thermal Sublimation:</strong> High-definition dye printing with vivid, scratch-resistant colors.<br>
        • <strong>Magnetic Mounting Kit:</strong> Ultra-strong magnetic wall mounts adhere cleanly to walls—<strong>zero drilling, tools, or nails required</strong>.<br>
        • <strong>Worldwide Tracked Shipping:</strong> Dispatched in rigid protective packaging in 5–10 business days worldwide.<br><br>
        <a href="/collections/posters" class="binge-chat-channel-btn" style="color:#fff;">🖼️ Browse Metal Wall Art Collection</a>`
    }
  };

  // --- STOREFRONT ANALYTICS DISPATCHER (CUSTOM EVENTS DISABLED) ---
  function trackGuideEvent(eventName, params = {}) {
    // Custom events deleted / disabled
  }

  // --- DOM ELEMENTS & STATE ---
  let triggerBtn, drawer, closeBtn, bodyElem, inputElem, sendBtn, unreadBadge, hiddenForm;
  let isOpen = false;
  let lastCloseMethod = 'button';

  // --- IYKYK PROMPT BUBBLE (PROACTIVE FANDOM ROTATOR) ---
  const IYKYK_HINTS = [
    { icon: '🔥', html: 'Check out our <strong>Best Sellers</strong>? ➔' },
    { icon: '⚡', html: 'Explore the <strong>Latest Universe Drops</strong>? ➔' },
    { icon: '🗳️', html: 'Vote for the <strong>Next Universe Drop</strong>? ➔' },
    { icon: '📎', html: 'Looking for <strong>Scranton Paper Co.</strong> lore? ➔' },
    { icon: '🏴‍☠️', html: 'Looking for <strong>Straw Hat Nakama</strong> voyages? ➔' },
    { icon: '⚗️', html: 'Looking for <strong>Desert Chemistry & Blue Glass</strong>? ➔' },
    { icon: '🚲', html: 'Looking for <strong>80s supernatural synth mysteries</strong>? ➔' },
    { icon: '☕', html: 'Looking for <strong>90s Coffeehouse couch</strong> vibes? ➔' },
    { icon: '⚔️', html: 'Looking for <strong>Flame Swords & Wisteria</strong>? ➔' },
    { icon: '🦇', html: 'Looking for <strong>Dark Vigilante</strong> drop? ➔' },
    { icon: '🍥', html: 'Looking for <strong>Hidden Village Shinobi</strong> lore? ➔' },
    { icon: '🛡️', html: 'Looking for <strong>Wings of Bastion</strong> sentinels? ➔' },
    { icon: '🌌', html: 'Looking for <strong>Galactic Twin Suns</strong>? ➔' }
  ];

  let bubbleElem, bubbleCloseBtn, bubbleContentElem;
  let bubbleTimer = null;
  let bubbleRotationInterval = null;
  let currentHintIndex = 0;

  function shouldAutoFocus() {
    // Never auto-focus on mobile or touch viewports to prevent virtual onscreen keyboards
    // from abruptly popping up, covering the screen, and ruining the initial experience
    if (window.innerWidth <= 768) return false;
    if ('ontouchstart' in window && window.innerWidth <= 1024) return false;
    if (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) return false;
    return true;
  }

  function initPromptBubble() {
    bubbleElem = document.getElementById('binge-chat-bubble');
    bubbleCloseBtn = document.getElementById('binge-chat-bubble-close');
    bubbleContentElem = document.getElementById('binge-chat-bubble-content');

    if (!bubbleElem) return;

    // Do not show if dismissed in this session or chat already opened
    if (sessionStorage.getItem('bc_guide_prompt_dismissed') === 'true' || sessionStorage.getItem('binge_chat_seen') === 'true') {
      return;
    }

    // Dismiss button
    if (bubbleCloseBtn) {
      bubbleCloseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        dismissPromptBubble();
      });
    }

    // Click bubble to open chat (only auto-focus on desktop)
    bubbleElem.addEventListener('click', () => {
      const activeHint = IYKYK_HINTS[currentHintIndex];
      dismissPromptBubble();
      setOpen(true);
      if (activeHint && activeHint.html.includes('Next Universe Drop')) {
        handleActionClick('next-drop');
      } else if (inputElem && shouldAutoFocus()) {
        inputElem.focus();
      }
    });

    // Delayed entrance (3.2 seconds after page load)
    bubbleTimer = setTimeout(() => {
      showPromptBubble();
    }, 3200);
  }

  function showPromptBubble() {
    if (!bubbleElem || isOpen || sessionStorage.getItem('bc_guide_prompt_dismissed') === 'true' || sessionStorage.getItem('binge_chat_seen') === 'true') return;

    updateBubbleHint(currentHintIndex);
    bubbleElem.style.display = 'block';
    // Trigger layout transition
    requestAnimationFrame(() => {
      bubbleElem.classList.add('is-visible');
    });

    // Start rotating hints every 4.2 seconds
    bubbleRotationInterval = setInterval(() => {
      rotateNextHint();
    }, 4200);
  }

  function rotateNextHint() {
    if (!bubbleElem || !bubbleContentElem || isOpen) return;
    currentHintIndex = (currentHintIndex + 1) % IYKYK_HINTS.length;

    bubbleContentElem.classList.add('is-transitioning');
    setTimeout(() => {
      updateBubbleHint(currentHintIndex);
      bubbleContentElem.classList.remove('is-transitioning');
    }, 200);
  }

  function updateBubbleHint(idx) {
    const hint = IYKYK_HINTS[idx];
    const iconElem = document.getElementById('binge-chat-bubble-icon');
    const textElem = document.getElementById('binge-chat-bubble-text');
    if (iconElem) iconElem.textContent = hint.icon;
    if (textElem) textElem.innerHTML = hint.html;
  }

  function dismissPromptBubble() {
    sessionStorage.setItem('bc_guide_prompt_dismissed', 'true');
    if (bubbleTimer) clearTimeout(bubbleTimer);
    if (bubbleRotationInterval) clearInterval(bubbleRotationInterval);
    if (bubbleElem) {
      bubbleElem.classList.remove('is-visible');
      setTimeout(() => {
        bubbleElem.style.display = 'none';
      }, 300);
    }
  }

  function initChat() {
    triggerBtn = document.getElementById('binge-chat-trigger');
    drawer = document.getElementById('binge-chat-drawer');
    closeBtn = document.getElementById('binge-chat-close');
    bodyElem = document.getElementById('binge-chat-body');
    inputElem = document.getElementById('binge-chat-input');
    sendBtn = document.getElementById('binge-chat-send');
    unreadBadge = document.getElementById('binge-chat-unread');
    hiddenForm = document.getElementById('BingeHiddenContactForm');

    if (!triggerBtn || !drawer || !bodyElem) return;

    // Initialize IYKYK prompt bubble
    initPromptBubble();

    triggerBtn.addEventListener('click', () => {
      lastCloseMethod = 'launcher_toggle';
      toggleChat();
    });
    closeBtn.addEventListener('click', () => {
      lastCloseMethod = 'close_button';
      setOpen(false);
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) {
        lastCloseMethod = 'escape_key';
        setOpen(false);
      }
    });

    // Send button & enter key
    if (sendBtn && inputElem) {
      sendBtn.addEventListener('click', handleUserSubmit);
      inputElem.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleUserSubmit();
        }
      });
    }

    // Ensure drawer is strictly hidden on initialization
    drawer.style.display = 'none';
    drawer.classList.remove('is-active');
    document.body.classList.remove('binge-chat-open');

    // Never show annoying reset unread badge on navigation
    if (unreadBadge) {
      unreadBadge.style.display = 'none';
    }

    // Render Initial Welcome Message
    renderWelcome();
  }

  function toggleChat() {
    setOpen(!isOpen);
  }

  function setOpen(open) {
    isOpen = open;

    if (isOpen) {
      trackGuideEvent('binge_guide_open', {
        trigger: 'launcher_button',
        page_path: window.location.pathname
      });

      dismissPromptBubble();
      sessionStorage.setItem('binge_chat_seen', 'true');
      drawer.style.display = 'flex';
      // Force layout flush so transition works smoothly
      void drawer.offsetHeight;
      drawer.classList.add('is-active');
      document.body.classList.add('binge-chat-open');

      if (unreadBadge) {
        unreadBadge.style.display = 'none';
      }
      setTimeout(() => {
        if (inputElem && shouldAutoFocus()) inputElem.focus();
        scrollToBottom();
      }, 150);
    } else {
      trackGuideEvent('binge_guide_close', {
        close_method: lastCloseMethod || 'button'
      });
      lastCloseMethod = 'button';

      drawer.classList.remove('is-active');
      document.body.classList.remove('binge-chat-open');
      setTimeout(() => {
        if (!isOpen) {
          drawer.style.display = 'none';
        }
      }, 220);
    }

    triggerBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  function scrollToBottom() {
    if (bodyElem) {
      bodyElem.scrollTop = bodyElem.scrollHeight;
    }
  }

  function getTimeString() {
    const d = new Date();
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  // --- MESSAGE RENDERING ---
  function appendBotMessage(htmlContent, showActions = false) {
    const msg = document.createElement('div');
    msg.className = 'binge-chat-msg binge-chat-msg--bot';
    msg.innerHTML = `
      <div class="binge-chat-msg-bubble">
        ${htmlContent}
        ${showActions ? getQuickPillsHtml() : ''}
      </div>
      <span class="binge-chat-msg-time">${getTimeString()}</span>
    `;
    bodyElem.appendChild(msg);
    bindActionPills(msg);
    scrollToBottom();
  }

  function appendUserMessage(text) {
    const msg = document.createElement('div');
    msg.className = 'binge-chat-msg binge-chat-msg--user';
    msg.innerHTML = `
      <div class="binge-chat-msg-bubble">
        ${escapeHtml(text)}
      </div>
      <span class="binge-chat-msg-time">${getTimeString()}</span>
    `;
    bodyElem.appendChild(msg);
    scrollToBottom();
  }

  function escapeHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getQuickPillsHtml() {
    return `
      <div class="binge-chat-actions">
        <button type="button" class="binge-chat-pill" data-action="hottest-sellers" style="background:#FFF3E0; border-color:#E99D32; font-weight:700;">🔥 Best Sellers</button>
        <button type="button" class="binge-chat-pill" data-action="latest-drops" style="background:#E8F5E9; border-color:#00C853; font-weight:700;">⚡ Latest Drops</button>
        <button type="button" class="binge-chat-pill" data-action="search-show">🔍 Search Shows</button>
        <button type="button" class="binge-chat-pill" data-action="next-drop">🗳️ Next Drop Vote</button>
        <button type="button" class="binge-chat-pill" data-action="sizing">📏 Size &amp; Fit</button>
        <button type="button" class="binge-chat-pill" data-action="shipping">🚚 Shipping Times</button>
        <button type="button" class="binge-chat-pill" data-action="contact">📩 Leave a Message</button>
        <button type="button" class="binge-chat-pill" data-action="fanart">🎨 Original Art</button>
      </div>
    `;
  }

  function bindActionPills(container) {
    // Top-level action pills
    const pills = container.querySelectorAll('.binge-chat-pill[data-action]');
    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const action = pill.getAttribute('data-action');
        trackGuideEvent('binge_guide_action_click', {
          action_type: action,
          action_label: pill.textContent.trim()
        });
        handleActionClick(action);
      });
    });

    // Upcoming Drop Dossier Navigator link
    const dossierLinks = container.querySelectorAll('[data-chat-nav-dossier]');
    dossierLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        navigateToDossier(e);
      });
    });

    // Quick channel search pills (e.g. Albuquerque Empire, 90s Sitcom, Scranton Branch)
    const showBtns = container.querySelectorAll('[data-search-show]');
    showBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const showName = btn.getAttribute('data-search-show');
        trackGuideEvent('binge_guide_quick_show_click', {
          show_name: showName
        });
        executeSearch(showName);
      });
    });

    // Request show button (if show not found)
    const reqBtns = container.querySelectorAll('[data-request-show]');
    reqBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const showName = btn.getAttribute('data-request-show');
        trackGuideEvent('binge_guide_request_show_click', {
          show_name: showName
        });
        showContactForm(`I'd love to see fan-art apparel for this title!`);
      });
    });

    // Size chart opener button
    const sizeChartBtn = container.querySelector('[data-chat-open-size-chart]');
    if (sizeChartBtn) {
      sizeChartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        trackGuideEvent('binge_guide_size_chart_open', {
          source: 'chat_sizing_prompt'
        });
        trackGuideEvent('binge_size_guide_open', {
          garment_category: 'all_apparel',
          source: 'binge_guide_chat'
        });
        const modal = document.getElementById('BingeSizeGuideModal');
        if (modal) {
          modal.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    }

    // Recommendation links: Channel cards inside chat
    container.querySelectorAll('a.binge-chat-channel-btn').forEach((link) => {
      link.addEventListener('click', () => {
        const card = link.closest('.binge-chat-channel-card');
        const channelTitle = card?.querySelector('.binge-chat-channel-title')?.textContent?.trim() || '';
        trackGuideEvent('binge_guide_channel_click', {
          channel_title: channelTitle,
          link_text: link.textContent.trim(),
          destination_url: link.getAttribute('href') || ''
        });
      });
    });

    // Recommendation links: Product cards inside carousel
    container.querySelectorAll('.binge-chat-prod-link').forEach((link) => {
      link.addEventListener('click', () => {
        const card = link.closest('.binge-chat-prod-card');
        const prodTitle = card?.querySelector('.binge-chat-prod-title')?.textContent?.trim() || '';
        const prodPrice = card?.querySelector('.binge-chat-prod-price')?.textContent?.trim() || '';
        trackGuideEvent('binge_guide_product_click', {
          product_title: prodTitle,
          product_price: prodPrice,
          destination_url: link.getAttribute('href') || ''
        });
      });
    });

    // Collection recommendation pills
    container.querySelectorAll('a.binge-chat-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        trackGuideEvent('binge_guide_collection_click', {
          collection_title: pill.textContent.trim(),
          destination_url: pill.getAttribute('href') || ''
        });
      });
    });

    // Contact form submit inside chat
    const contactForm = container.querySelector('#BingeChatInlineForm');
    if (contactForm) {
      contactForm.addEventListener('submit', handleContactFormSubmit);
    }
  }

  function renderWelcome() {
    const welcomeHtml = `
      <strong>Welcome to The Binge Club Broadcast! 📺</strong><br>
      I'm your retro remote control assistant. Looking for apparel inspired by your favorite universe, sizing specs, or delivery estimates? Search our guide or pick a topic below:
    `;
    appendBotMessage(welcomeHtml, true);
  }

  // --- ACTIONS HANDLER ---
  function handleActionClick(action) {
    switch (action) {
      case 'hottest-sellers':
        appendUserMessage('Show me your hottest sellers!');
        showHottestSellers();
        break;
      case 'latest-drops':
        appendUserMessage('What are your latest universe drops?');
        showLatestDrops();
        break;
      case 'search-show':
        appendUserMessage('Search for a collection or channel.');
        showSearchShowPrompt();
        break;
      case 'next-drop':
        appendUserMessage('Where can I see the upcoming drop and cast my vote?');
        showNextDropVoteInfo();
        break;
      case 'sizing':
        appendUserMessage('What are the sizing details?');
        showSizingGuide();
        break;
      case 'shipping':
        appendUserMessage('How long does shipping take?');
        showShippingInfo();
        break;
      case 'contact':
        appendUserMessage('I want to leave a message for the crew.');
        showContactForm();
        break;
      case 'fanart':
        appendUserMessage('Tell me about your original designs and philosophy.');
        showFanArtStatement();
        break;
    }
  }

  async function showHottestSellers() {
    appendBotMessage('<strong>🔥 Tuning into our Best Sellers:</strong><br>Here are the fan-favorite pieces currently flying off the print press across all universes:<br><br><div class="binge-chat-loading">Scanning broadcast frequencies...</div>', false);
    
    try {
      const res = await fetch('/collections/best-sellers/products.json?limit=4');
      const data = await res.json();
      const prods = data?.products || [];
      
      let html = '<strong>🔥 Current Best Sellers & Fan Favorites:</strong><br>';
      html += 'Printed fresh on premium heavyweight ringspun combed cotton & cozy fleece:<br><br>';
      
      if (prods.length > 0) {
        prods.forEach(p => {
          const img = p.images?.[0]?.src ? `<img src="${p.images[0].src}" style="width:48px;height:48px;object-fit:cover;border:1.5px solid #161513;border-radius:6px;flex-shrink:0;">` : '';
          html += `
            <a href="/products/${p.handle}" class="binge-chat-channel-btn" style="text-decoration:none;display:flex;align-items:center;gap:10px;margin-bottom:8px;padding:8px 10px;text-align:left;">
              ${img}
              <div style="flex-grow:1;min-width:0;">
                <div style="font-weight:700;font-size:1.25rem;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHtml(p.title)}</div>
                <div style="font-size:1.1rem;opacity:0.75;margin-top:2px;">View Product ➔</div>
              </div>
            </a>
          `;
        });
      }
      
      html += `
        <a href="/collections/best-sellers" class="binge-chat-channel-btn" style="display:block;text-align:center;font-weight:700;background:#E99D32;color:#161513;margin-top:10px;text-decoration:none;padding:10px 14px;">
          🔥 Browse All Best Sellers ➔
        </a>
        <div class="binge-chat-actions" style="margin-top: 10px;">
          <button type="button" class="binge-chat-pill" data-action="latest-drops">⚡ Latest Drops</button>
          <button type="button" class="binge-chat-pill" data-action="search-show">🔍 Browse Universes</button>
        </div>
      `;
      
      const msgs = messagesContainer.querySelectorAll('.binge-chat-msg-bot');
      if (msgs.length > 0) {
        msgs[msgs.length - 1].querySelector('.binge-chat-bubble').innerHTML = html;
        bindActionPills(msgs[msgs.length - 1]);
      } else {
        appendBotMessage(html, false);
      }
    } catch (e) {
      appendBotMessage('<strong>🔥 Best Sellers:</strong><br><a href="/collections/best-sellers" class="binge-chat-channel-btn" style="display:block;text-align:center;font-weight:700;background:#E99D32;color:#161513;text-decoration:none;padding:10px 14px;">🔥 Browse All Best Sellers ➔</a>', false);
    }
  }

  function showLatestDrops() {
    const latestHandles = ["flight-of-the-court","cursed-sorcerers","cursed-buccaneer","underground-society"];
    const latestList = CHANNELS.filter(c => latestHandles.includes(c.handle));

    let html = '<strong>⚡ Fresh From The Print Lab: Latest Collections</strong><br>';
    html += 'Our most recent comfort-watch universe drops unlocked for the Club:<br><br>';

    latestList.forEach(ch => {
      html += `
        <div style="background:#FFFDF9;border:1.5px solid #161513;border-radius:8px;padding:10px;margin-bottom:10px;box-shadow:2px 2px 0 #161513;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
            <strong style="font-size:1.35rem;">${ch.title}</strong>
            <span style="font-size:0.95rem;background:#00E676;color:#161513;font-weight:800;border:1.5px solid #161513;border-radius:4px;padding:1px 6px;">NEW DROP</span>
          </div>
          <p style="font-size:1.15rem;color:#555;line-height:1.35;margin:0 0 8px 0;">${escapeHtml(ch.desc)}</p>
          <a href="${ch.url}" class="binge-chat-channel-btn" style="display:block;text-align:center;font-weight:700;text-decoration:none;padding:8px 12px;font-size:1.2rem;">
            Explore ${escapeHtml(ch.title.replace(/^[^\s]+\s+/, ''))} Collection ➔
          </a>
        </div>
      `;
    });

    html += `
      <div class="binge-chat-actions" style="margin-top: 6px;">
        <button type="button" class="binge-chat-pill" data-action="hottest-sellers">🔥 Best Sellers</button>
        <button type="button" class="binge-chat-pill" data-action="next-drop">🗳️ Next Drop Vote</button>
      </div>
    `;
    appendBotMessage(html, false);
  }

  function showNextDropVoteInfo() {
    const dropHtml = `
      <strong>🗳️ Upcoming Universe Drop &amp; Community Voting:</strong><br>
      Every month, our community votes to decide which cult show, movie, or anime universe gets unlocked next!<br><br>
      You can also inspect our <strong>Print Lab Cipher Dossier</strong> to decrypt teaser clues for the drop currently in production.<br><br>
      <button type="button" class="binge-chat-channel-btn" data-chat-nav-dossier style="cursor:pointer; border:none; text-align:center; width:100%; display:block; padding:10px 14px; font-weight:700;">
        🔍 Open Upcoming Drop Dossier &amp; Vote ➔
      </button>
      <div class="binge-chat-actions" style="margin-top: 10px;">
        <button type="button" class="binge-chat-pill" data-action="search-show">🔍 Browse Current Universes</button>
        <button type="button" class="binge-chat-pill" data-action="contact">📩 Suggest A Universe</button>
      </div>
    `;
    appendBotMessage(dropHtml, false);
  }

  function navigateToDossier(e) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    trackGuideEvent('binge_guide_action_click', {
      action_type: 'navigate_dossier',
      action_label: 'Upcoming Drop Dossier & Vote'
    });
    setOpen(false);

    const isHome = window.location.pathname === '/' || window.location.pathname === '';
    if (isHome) {
      const target = document.getElementById('bc-dossier-card') || document.getElementById('UpcomingDrops') || document.getElementById('Newsletter');
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const dossierCard = document.getElementById('bc-dossier-card');
          if (dossierCard) {
            dossierCard.style.transition = 'box-shadow 0.4s ease, border-color 0.4s ease, transform 0.4s ease';
            dossierCard.style.borderColor = '#00E676';
            dossierCard.style.boxShadow = '0 0 25px rgba(0, 230, 118, 0.6)';
            dossierCard.style.transform = 'scale(1.02)';
            setTimeout(() => {
              dossierCard.style.borderColor = '';
              dossierCard.style.boxShadow = '';
              dossierCard.style.transform = '';
            }, 2500);
          }
        }, 250);
        return;
      }
    }
    // If not on homepage or target not found, redirect to homepage anchor
    window.location.href = '/#UpcomingDrops';
  }

  function showSearchShowPrompt() {
    const promptHtml = `
      <strong>🔍 Search Our Broadcast Guide:</strong><br>
      Type any title, theme, or scene into the box below, or tap a featured channel:
      <div class="binge-chat-actions" style="margin-top: 8px;">
        <button type="button" class="binge-chat-pill" data-search-show="90s Sitcom">📺 90s Sitcom</button>
        <button type="button" class="binge-chat-pill" data-search-show="Albuquerque Empire">🧪 Albuquerque Empire</button>
        <button type="button" class="binge-chat-pill" data-search-show="Scranton Branch">📎 Scranton Branch</button>
        <button type="button" class="binge-chat-pill" data-search-show="Iron Realm">🐉 Iron Realm</button>
        <button type="button" class="binge-chat-pill" data-search-show="Dark Vigilante">🦇 Dark Vigilante</button>
        <button type="button" class="binge-chat-pill" data-search-show="Pirate King">🏴‍☠️ Pirate King</button>
      </div>
    `;
    appendBotMessage(promptHtml, false);
    if (inputElem) {
      inputElem.placeholder = "Type a title, scene, or theme...";
      if (shouldAutoFocus()) inputElem.focus();
    }
  }

  function showSizingGuide() {
    let html = KNOWLEDGE.sizing.text;
    html += `<br><br><button type="button" class="binge-chat-channel-btn" data-chat-open-size-chart style="cursor:pointer; border:none;">📐 Open Full Interactive Size Guide</button>`;
    appendBotMessage(html, true);
  }

  function showShippingInfo() {
    appendBotMessage(KNOWLEDGE.shipping.text, true);
  }

  function showFanArtStatement() {
    const fanArtHtml = `
      ${KNOWLEDGE.fanArt.text}<br><br>
      <strong>Looking for a specific title or collection?</strong>
      <div class="binge-chat-actions" style="margin-top: 8px;">
        <button type="button" class="binge-chat-pill" data-action="search-show">🔍 Search Our Guide</button>
        <button type="button" class="binge-chat-pill" data-action="contact">📩 Request A Design</button>
      </div>
    `;
    appendBotMessage(fanArtHtml, false);
  }

  function showContactForm(prefillMessage = '') {
    const formHtml = `
      <strong>📩 Transmission to the Binge Club Crew:</strong><br>
      Send us your question, custom apparel request, or sizing query. Our team will review it and reply directly to your email!
      <form id="BingeChatInlineForm" class="binge-chat-contact-box">
        <div class="binge-chat-form-group">
          <label class="binge-chat-form-label">Your Name</label>
          <input type="text" name="name" class="binge-chat-input" placeholder="e.g. Alex Mercer" required>
        </div>
        <div class="binge-chat-form-group">
          <label class="binge-chat-form-label">Your Email</label>
          <input type="email" name="email" class="binge-chat-input" placeholder="you@domain.com" required>
        </div>
        <div class="binge-chat-form-group">
          <label class="binge-chat-form-label">Order # (Optional)</label>
          <input type="text" name="order" class="binge-chat-input" placeholder="e.g. #1042">
        </div>
        <div class="binge-chat-form-group">
          <label class="binge-chat-form-label">Your Message</label>
          <textarea name="message" class="binge-chat-textarea" placeholder="How can we help you?" required>${escapeHtml(prefillMessage)}</textarea>
        </div>
        <button type="submit" id="BingeChatSubmitBtn" class="binge-chat-form-submit">
          <span>Beep Transmission</span> 🚀
        </button>
      </form>
    `;
    appendBotMessage(formHtml, false);
  }

  async function handleContactFormSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const submitBtn = form.querySelector('#BingeChatSubmitBtn');
    const nameVal = form.name.value.trim();
    const emailVal = form.email.value.trim();
    const orderVal = form.order.value.trim();
    const messageVal = form.message.value.trim();

    if (!nameVal || !emailVal || !messageVal) return;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Beaming Transmission... 📡';
    }

    try {
      let fullBody = `[Binge Guide Inquiry]\nFrom: ${nameVal}\nEmail: ${emailVal}\n`;
      if (orderVal) fullBody += `Order Number: ${orderVal}\n`;
      fullBody += `\nMessage:\n${messageVal}`;

      const hName = document.getElementById('BingeHiddenName');
      const hEmail = document.getElementById('BingeHiddenEmail');
      const hOrder = document.getElementById('BingeHiddenOrder');
      const hBody = document.getElementById('BingeHiddenBody');
      const hForm = document.getElementById('BingeHiddenContactForm');

      if (hName) hName.value = nameVal;
      if (hEmail) hEmail.value = emailVal;
      if (hOrder) hOrder.value = orderVal;
      if (hBody) hBody.value = fullBody;

      const postUrl = hForm ? hForm.getAttribute('action') || '/contact' : '/contact';
      const formData = hForm ? new FormData(hForm) : new FormData();
      if (!hForm) {
        formData.append('form_type', 'contact');
        formData.append('utf8', '✓');
        formData.append('contact[name]', nameVal);
        formData.append('contact[email]', emailVal);
        formData.append('contact[body]', fullBody);
      }

      await fetch(postUrl, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8' }
      });

      const successHtml = `
        <div style="background: rgba(0, 230, 118, 0.12); border: 1.5px solid #00E676; border-radius: 8px; padding: 12px; color: #161513;">
          <strong style="color: #0b8043;">✅ Transmission Received!</strong><br>
          Thank you, <strong>${escapeHtml(nameVal)}</strong>. Your inquiry has been sent directly to the Binge Club crew.<br><br>
          We'll review your transmission and reply to <strong>${escapeHtml(emailVal)}</strong> shortly.
        </div>
      `;
      trackGuideEvent('binge_guide_transmission_submit', {
        has_order_number: Boolean(orderVal),
        inquiry_type: orderVal ? 'order_help' : 'show_or_general_request'
      });
      appendBotMessage(successHtml, true);
    } catch (err) {
      console.error('Contact form error:', err);
      const fallbackHtml = `
        <div style="background: rgba(217, 72, 59, 0.1); border: 1.5px solid #D9483B; border-radius: 8px; padding: 12px;">
          <strong>Transmission Glitch:</strong> We could not beam your message automatically. Please email our crew directly at <a href="mailto:support@thebingeclub.co" style="color: #D9483B; font-weight: 700;">support@thebingeclub.co</a> and we will assist you immediately!
        </div>
      `;
      appendBotMessage(fallbackHtml, true);
    }
  }

  // --- USER TEXT INPUT & SMART SEARCH ---
  function handleUserSubmit() {
    if (!inputElem) return;
    const query = inputElem.value.trim();
    if (!query) return;

    inputElem.value = '';
    executeSearch(query);
  }

  function executeSearch(query) {
    appendUserMessage(query);
    processQuery(query);
  }

  async function processQuery(rawQuery) {
    const q = rawQuery.toLowerCase();

    // Check Hottest Sellers query
    if (q.includes('hottest') || q.includes('best seller') || q.includes('trending') || q.includes('popular apparel')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'hottest-sellers' });
      showHottestSellers();
      return;
    }

    // Check Latest Drops query
    if (q.includes('latest') || q.includes('new drop') || q.includes('new release') || q.includes('newest universe') || q.includes('recent universe')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'latest-drops' });
      showLatestDrops();
      return;
    }

    // Check Next Drop / Voting / Dossier / Cipher keywords
    if (q.includes('vote') || q.includes('next drop') || q.includes('upcoming') || q.includes('dossier') || q.includes('cipher') || q.includes('nominate') || q.includes('next universe')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'next-drop' });
      showNextDropVoteInfo();
      return;
    }

    // Check policies / FAQ keywords first
    if (q.includes('size') || q.includes('sizing') || q.includes('fit') || q.includes('measurement') || q.includes('large') || q.includes('small') || q.includes('oversized')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'sizing' });
      showSizingGuide();
      return;
    }

    if (q.includes('ship') || q.includes('delivery') || q.includes('track') || q.includes('how long') || q.includes('transit') || q.includes('arrive') || q.includes('where is my order')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'shipping' });
      showShippingInfo();
      return;
    }

    if (q.includes('contact') || q.includes('email') || q.includes('support') || q.includes('help') || q.includes('human') || q.includes('message')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'contact' });
      showContactForm();
      return;
    }

    if (q.includes('return') || q.includes('refund') || q.includes('exchange') || q.includes('damaged') || q.includes('defective')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'returns' });
      appendBotMessage(KNOWLEDGE.returns.text, true);
      return;
    }

    if (q.includes('care') || q.includes('wash') || q.includes('shrink') || q.includes('dry') || q.includes('iron')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'care' });
      appendBotMessage(KNOWLEDGE.care.text, true);
      return;
    }

    if (q.includes('trademark') || q.includes('copyright') || q.includes('license') || q.includes('fan art') || q.includes('official') || q.includes('lore')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'fanart' });
      showFanArtStatement();
      return;
    }

    if (q.includes('poster') || q.includes('posters') || q.includes('displate') || q.includes('wall art') || q.includes('metal print') || q.includes('aluminum')) {
      trackGuideEvent('binge_guide_faq_query', { query: rawQuery, topic: 'posters' });
      appendBotMessage(KNOWLEDGE.posters.text, true);
      return;
    }

    // Otherwise, execute smart show / universe search!
    await searchShowAndProducts(rawQuery);
  }

  const GARMENT_TERMS = ['hoodie', 'hoodies', 'sweatshirt', 'sweatshirts', 'crewneck', 'crewnecks', 'shirt', 'shirts', 'tshirt', 't-shirt', 'tee', 'tees', 'merch', 'apparel', 'clothing', 'top', 'gift', 'black', 'white', 'oversized', 'jacket'];

  async function searchShowAndProducts(query) {
    const q = query.toLowerCase().trim();

    // Check if query matches any known channel alias
    let matchedChannel = null;

    // 1. Anonymous cryptographic hash vault lookup (ZERO plaintext IP in code)
    if (window.BingeUniverseResolver && typeof window.BingeUniverseResolver.match === 'function') {
      const vaultMatchHandle = window.BingeUniverseResolver.match(query);
      if (vaultMatchHandle) {
        matchedChannel = CHANNELS.find((c) => c.handle === vaultMatchHandle || c.id === vaultMatchHandle);
        if (!matchedChannel) {
          // Dynamic fallback: Auto-construct channel card so ANY newly added collection works instantly!
          const cleanTitle = vaultMatchHandle.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
          matchedChannel = {
            id: vaultMatchHandle,
            title: '📺 ' + cleanTitle,
            handle: vaultMatchHandle,
            desc: 'Curated franchise universe — graphic streetwear, luxury heavyweight hoodies, and original genre apparel.',
            url: '/collections/' + vaultMatchHandle
          };
        }
      }
    }

    // 2. Direct channel title/handle search
    if (!matchedChannel) {
      matchedChannel = CHANNELS.find((c) => c.title.toLowerCase().includes(q) || c.handle.toLowerCase().includes(q));
    }

    const isGarmentQuery = GARMENT_TERMS.some((term) => q.includes(term));

    try {
      let products = [];
      let collections = [];

      if (matchedChannel) {
        // ALWAYS fetch products directly from the matched channel's collection!
        // This guarantees 100% franchise isolation and prevents Shopify's sitewide full-text
        // predictive search from leaking other shows' products that happen to contain common words.
        try {
          const colRes = await fetch(`/collections/${matchedChannel.handle}/products.json?limit=12`);
          if (colRes.ok) {
            const colData = await colRes.json();
            const colProds = (colData.products || []).map((cp) => ({
              title: cp.title,
              url: `/products/${cp.handle}`,
              price: cp.variants && cp.variants[0] ? cp.variants[0].price : '',
              image: cp.images && cp.images[0] ? cp.images[0].src : '',
              product_type: cp.product_type || ''
            }));

            if (isGarmentQuery) {
              const matchedGarmentTerms = GARMENT_TERMS.filter((term) => q.includes(term));
              const filtered = colProds.filter((p) => {
                const combined = (p.title + ' ' + p.product_type).toLowerCase();
                return matchedGarmentTerms.some((term) => combined.includes(term));
              });
              products = filtered.length > 0 ? filtered.slice(0, 6) : colProds.slice(0, 6);
            } else {
              products = colProds.slice(0, 6);
            }
          }
        } catch (colErr) {
          console.warn('Could not fetch collection products:', colErr);
        }
      } else {
        // Query Shopify predictive search for real-time products & collections
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6`);
        if (!res.ok) throw new Error('Search failed');
        const data = await res.json();
        const rawProducts = data.resources?.results?.products || [];
        collections = data.resources?.results?.collections || [];

        // Filter products for genuine relevance if searching for a specific show title
        products = rawProducts;
        if (!isGarmentQuery) {
          const qWords = q.split(/\s+/).filter((w) => w.length > 2);
          if (qWords.length > 0) {
            products = rawProducts.filter((p) => {
              const titleLower = p.title.toLowerCase();
              return qWords.every((w) => titleLower.includes(w));
            });
          }
        }
      }

      // If neither channel nor genuine products found -> Show friendly missing broadcast + request button
      if (!matchedChannel && products.length === 0 && collections.length === 0) {
        trackGuideEvent('binge_guide_search_not_found', {
          query: query
        });
        const notFoundHtml = `
          <div style="background: #FFFDF9; border: 1.5px solid #161513; border-radius: 8px; padding: 12px; box-shadow: 2px 2px 0px #161513;">
            <strong style="font-size: 1.4rem;">📡 No Matching Channel Found</strong><br><br>
            We don't have apparel or a dedicated channel tuned into that title on our airwaves just yet!<br><br>
            Our design crew is continually expanding our broadcast guide with new cult favorites. Would you like to suggest this title for an upcoming drop?
            <div style="margin-top: 10px;">
              <button type="button" class="binge-chat-channel-btn" data-request-show="${escapeHtml(query)}" style="cursor: pointer; border: 1.5px solid #161513;">
                📩 Request Apparel Drop
              </button>
            </div>
          </div>
          <div class="binge-chat-actions" style="margin-top: 8px;">
            <button type="button" class="binge-chat-pill" data-action="search-show">🔍 Try Another Search</button>
            <button type="button" class="binge-chat-pill" data-action="sizing">📏 Size &amp; Fit</button>
          </div>
        `;
        appendBotMessage(notFoundHtml, false);
        return;
      }

      trackGuideEvent('binge_guide_search_results', {
        query: query,
        matched_channel: matchedChannel ? matchedChannel.title : 'none',
        products_count: products.length,
        collections_count: collections.length
      });

      // Build unified found response without displaying show names
      let resultsHtml = '';
      if (matchedChannel) {
        resultsHtml = `<strong>📺 We already have that show in store!</strong> Tune into our channel below to browse the collection:<br>`;
        resultsHtml += `
          <div class="binge-chat-channel-card" style="margin: 8px 0;">
            <div class="binge-chat-channel-card-head">
              <h4 class="binge-chat-channel-title">${matchedChannel.title}</h4>
              <span class="binge-chat-channel-tag">In Store Now</span>
            </div>
            <p class="binge-chat-channel-desc">${matchedChannel.desc}</p>
            <a href="${matchedChannel.url}" class="binge-chat-channel-btn">Tune In to Channel ➔</a>
          </div>
        `;
      } else {
        resultsHtml = `<strong>📺 Matching Channels &amp; Apparel:</strong><br>`;
      }

      // 2. Render matching products carousel
      if (products.length > 0) {
        resultsHtml += `<div class="binge-chat-products-scroll">`;
        products.forEach((p) => {
          const formattedPrice = p.price ? `$${parseFloat(p.price).toFixed(2)}` : '';
          const imgUrl = p.image || '//thebingeclub.co/cdn/shop/files/bingeclub.jpg';
          resultsHtml += `
            <div class="binge-chat-prod-card">
              <img src="${imgUrl}" alt="${escapeHtml(p.title)}" class="binge-chat-prod-img" loading="lazy">
              <h5 class="binge-chat-prod-title">${escapeHtml(p.title)}</h5>
              ${formattedPrice ? `<span class="binge-chat-prod-price">${formattedPrice}</span>` : ''}
              <a href="${p.url}" class="binge-chat-prod-link">View Product ➔</a>
            </div>
          `;
        });
        resultsHtml += `</div>`;
      }

      // 3. Render collections if matched and not already the channel
      if (collections.length > 0 && !matchedChannel) {
        resultsHtml += `<div style="margin-top: 8px; font-size: 1.2rem;"><strong>Matching Channels:</strong></div><div class="binge-chat-actions">`;
        collections.forEach((c) => {
          resultsHtml += `<a href="${c.url}" class="binge-chat-pill" style="text-decoration:none;">📺 ${escapeHtml(c.title)}</a>`;
        });
        resultsHtml += `</div>`;
      }

      // Follow-up actions
      resultsHtml += `
        <div class="binge-chat-actions" style="margin-top: 8px;">
          <button type="button" class="binge-chat-pill" data-action="search-show">🔍 Search Another Title</button>
          <button type="button" class="binge-chat-pill" data-action="contact">📩 Custom Request</button>
        </div>
      `;

      appendBotMessage(resultsHtml, false);
    } catch (err) {
      console.error('Search error:', err);
      appendBotMessage(`
        Sorry, we had trouble searching our airwaves just now. You can try searching another title or leave a message!
      `, true);
    }
  }

  // Auto initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChat);
  } else {
    initChat();
  }
})();
